import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import {useSelector} from "react-redux";
import {userCan} from "../../../Components/Helpers/Utils";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {useCallback} from "react";

const GeneralCard = () => {
    const {product, dispatch, errors} = useNewProduct();
    const user = useSelector(state => state.user);
    const isAdmin = user?.isAdminType;

    const handleDescriptionChange = useCallback((event, editor) => {
        const data = editor.getData();
        if (data !== product.description) {
            dispatch({
                type: TYPES.SET_PRODUCT,
                payload: { ...product, description: data }
            });
        }
    }, [product, dispatch]);


    return (
        <div className="card card-flush py-4">
            <div className="card-header">
                <div className="card-title">
                    <h2>General</h2>
                </div>
            </div>
            <div className="card-body pt-0">
                <div className="mb-10 fv-row">
                  {(isAdmin || userCan(user?.permissions, 'Product Publish')) && (
                    <div className="mb-10 inline w-25">
                      <label className="form-label required">Publish</label>
                      <select className="form-select mb-2" data-control="select2" data-hide-search="true"
                              data-placeholder="Select an option" id="kt_ecommerce_add_product_status_select"
                              value={product?.published}
                              onChange={event => dispatch({
                                type: TYPES.SET_PRODUCT,
                                payload: {...product, published: event.target.value}
                              })}>
                        <option>Select publish</option>
                        <option  value={true}>True</option>
                        <option  value={false}>False</option>
                      </select>

                      {
                        errors?.published && (
                          <div className="fs-7 mb-7 text-danger">{errors.published}</div>
                        )
                      }
                    </div>
                  )}
                    <div className="mb-10 inline">
                        <label className="form-label">Select Publish Date(Optional)</label>
                        <input type="datetime-local" name="published_at"
                               className="w-25 form-control"
                               value={product.published_at ?? ""}
                               onChange={event => dispatch({
                                   type: TYPES.SET_PRODUCT,
                                   payload: {...product, published_at: event.target.value}
                               })}
                        />
                    </div>
                </div>
                <div className="mb-10 fv-row">
                    <label className="required form-label">Product Name</label>
                    <input type="text" name="product_name" className="form-control mb-2"
                           placeholder="Product name" value={product.name ?? ""} onChange={event => dispatch({
                        type: TYPES.SET_PRODUCT,
                        payload: {...product, name: event.target.value}
                    })}
                    />
                    {
                        errors.hasOwnProperty("name") && (
                            <div className="fs-7 mb-7 text-danger">{errors.name}</div>
                        )
                    }
                    <div className="text-muted fs-7">A product name is required and
                        recommended to be unique.
                    </div>
                </div>

              {
                (isAdmin && product?.id) && (
                  <div className="mb-10 fv-row">
                    <label className="required form-label">Slug</label>
                    <input type="text" name="slug" className="form-control mb-2"
                           placeholder="Product name" value={product.slug ?? ""} onChange={event => dispatch({
                      type: TYPES.SET_PRODUCT,
                      payload: {...product, slug: event.target.value}
                    })}
                    />
                    {
                      errors.hasOwnProperty("slug") && (
                        <div className="fs-7 mb-7 text-danger">{errors.slug}</div>
                      )
                    }
                    <div className="text-muted fs-7">A product slug is required and
                      must be unique.
                    </div>
                  </div>
                )
              }

                <div>
                    <label className="form-label">Description</label>

                    <div id="kt_ecommerce_add_product_description"
                         name="kt_ecommerce_add_product_description"
                         className="min-h-200px mb-2"
                    >
                        {/*<textarea*/}
                        {/*    className="form-control"*/}
                        {/*    style={{resize: "none", height: "200px"}}*/}
                        {/*    aria-label="With textarea"*/}
                        {/*    onChange={event => dispatch({*/}
                        {/*        type: TYPES.SET_PRODUCT,*/}
                        {/*        payload: {...product, description: event.target.value}*/}
                        {/*    })}*/}
                        {/*    value={product.description ?? ""}*/}
                        {/*>*/}
                        {/*</textarea>*/}
                        <CKEditor
                            editor={ClassicEditor}
                            data={product.description ?? ""}
                            onChange={handleDescriptionChange}
                        />
                    </div>
                    {
                        errors.hasOwnProperty("description") && (
                            <div className="fs-7 mb-7 text-danger">{errors.description}</div>
                        )
                    }
                    <div className="text-muted fs-7">
                        Set a description to the product for better visibility.
                    </div>
                </div>

              <div className="mt-4">
                <label className="form-label">Keywords</label>

                <div id="kt_ecommerce_add_product_description"
                     name="kt_ecommerce_add_product_description"
                     className="min-h-150px mb-2"
                >
                        <textarea
                          className="form-control"
                          style={{resize: "none", height: "150px"}}
                          aria-label="With textarea"
                          onChange={event => dispatch({
                            type: TYPES.SET_PRODUCT,
                            payload: {...product, keywords: event.target.value}
                          })}
                          value={product.keywords ?? ""}
                        >
                        </textarea>
                </div>
                {
                  errors.hasOwnProperty("keywords") && (
                    <div className="fs-7 mb-7 text-danger">{errors.keywords}</div>
                  )
                }
                <div className="text-muted fs-7">
                  Set keywords to the product separated by comma ( ex: word1, word2, word3 )
                </div>
              </div>
            </div>
        </div>
    )
}

export default GeneralCard;